export default {
    okText: '确认',
    closeText: '关闭',
    cancelText: '取消',
    urgentText: '加急',
    loadingText: '加载中...',
    resetText: '重置',
    searchText: '搜索',
    queryText: '查询',
    advancedQueryText: '高级查询',
    closeAdvancedQueryText: '关闭高级查询',
    editText: '编辑',
    saveText: '保存',
    savingText: '保存中',
    delText: '删除',
    bulkDelText: '批量删除',
    bulkInactiveText: '批量禁用',
    bulkLogoutText: '批量下线',
    bulkDelCancelText: '批量取消',
    bulkDelRestoreText: '批量释放',
    addText: '新增',
    backText: '返回',
    discardText: '弃用',
    settingText: '设置',
    settingText1: '配置',
    restoreDefaultText: '恢复默认',
    checkAllText: '全选',
    refreshText: '刷新',
    operationText: '操作',
    viewText: '查看',
    changeText: '切换',
    currentUserText: '当前用户',
    viewMoreText: '查看更多',
    markText: '已安排',
    downloadTemplateText: '下载模板',
    downloadText: '下载',
    labelDownloadText: '下载面单',
    batchDownloadText: '批量下载',
    importDataText: '导入数据',
    inputText: '请输入',
    inputPlusText: '不能输入特殊字符',
    chooseText: '请选择',
    detailsText: '详情',
    submitText: '提交',
    closeOthersText: '关闭其他',
    closeAllText: '关闭全部',
    operationLogText: '操作日志',
    logText: '日志',
    emptyText: '清空',
    importText: '导入',
    exportText: '导出',
    exportFullText: '全量导出',
    countryText: '国家/州',
    cityText: '市',
    districtNameText: '区',
    detailAddressText: '详细地址',
    postcodeText: '邮编',
    emptyWarningText: '不能为空',
    emptyWarningText1: '不能为0或空',
    customerNameText: '客户名称',
    clientCodeText: '客户编码',
    delegatedOperationText: '代客操作',
    cancelDelegatedOperationText: '结束代客操作',
    delegateOnceText: '以客户身份登录',
    confirmDelegateOperationText: '确认以客户「{customerName} - {clientCode}」身份登录？操作将直接影响该客户的数据。',
    confirmCancelDelegatedOperationText: '结束代客操作，返回您自己的账户',
    inputCustomerNameText: '请输入客户名称',
    confirmOperationText: '确认操作？',
    langText: '语言',
    online: '上线',
    line: '下线',
    table: {
        countText: '序号',
        statusText: '状态',
        operationText: '操作',
        hideSearchText: '隐藏搜索',
        showSearchText: '显示搜索',
        createTimeText: '创建时间',
        remarkText: '备注',
        auditText: '审核',
        creatorText: '创建者',
        emptyText: '暂无数据',
        createdByText: '创建人',
    },
    toast: {
        hintText: '提示',
        okText: '确定',
        cancelText: '取消',
        deletionConfirmationText: '是否确定删除该数据?',
        batchDeleteText: '是否批量删除这些数据?',
        operationSuccessText: '操作成功',
        hjSuccessText: '操作成功，HJ订单状态 将伴随页面五秒后进行刷新！',
        delEnabledTipText: '您选中了正在启用的数据，不可删除',
        delAllTipText: '您正在删除所选的数据，是否继续?',
        continueTipText: '是否继续?',
        AboutToExport: '正在导出',
        waitText: '条数据，请稍后',
        ManualText: '点击下载用户手册',
        youAreTipText: '您正在',
        youAreDelTipText: '您正在删除',
        submitSuccessText: '提交成功',
        deleteSuccessText: '删除成功',
        login: '的登录账户为',
        operationText: '操作中，是否继续？',
    },
    form: {
        oddNumbers: '单号',
        startDateText: '开始日期',
        endDateText: '结束日期',
        startTimeText: '开始时间',
        endTimeText: '结束时间',
    },
    personal: {
        title: '个人信息',
        avatarSetting: '修改头像',
        loginName: '登录账号',
        name: '名称',
        tenant: '所属租户',
        tenantName: 'CSG',
        validityPeriod: '有效期从',
        APIKey: 'API 密钥',
        APIbtn: '新增API连接',
        safetySet: '安全设置',
        password: '密码',
        passwordText: '安全性高的密码可以使账号更安全。建议您定期更换密码，设置一个包含字母，符号或数字中至少两项长度超过6位的密码。',
        hasBeenSet: '已设置',
        notSet: '未设置',
        revise: '修 改',
        mobileBinding: '手机绑定',
        verified: '已验证',
        unverified: '未验证',
        bind: '绑定',
        bound: '已绑定',
        verify: '请验证',
        phoneNumber: '手机号',
        phoneNumberText: '（手机号可用于登录、密码找回）',
        emailBinding: '邮箱绑定',
        email: '邮箱',
        emailText: '(邮箱可用于登录、密码找回)',
        changePassword: '修改密码',
        originalPassword: '原密码',
        originalPasswordText: '请输入原密码',
        newPassword: '新密码',
        newPasswordText: '请输入新密码',
        checkPass: '确认新密码',
        checkPassText: '请输入新密码',
        verificationCode: '验证码',
        verifyPassword: '验证密码',
        passwordValidation: '密码验证',
        enterPasswordText: '请输入密码',
        passwordErrorMsg1: '请再次输入密码',
        passwordErrorMsg2: '两次输入密码不一致!',
        emailErrorMsg1: '请输入邮箱地址',
        emailErrorMsg2: '请输入正确的邮箱地址',
        sendVerificationCode: '发送验证码',
        getVerificationCode: '获取验证码',
        verificationCodeText: '请输入验证码',
        phoneErrorMsg: '请输入正确的手机号码',
        reacquire: '重新获取',
        avatarErrorMsg1: '上传图片只能是 JPG 或者 PNG 格式!',
        avatarErrorMsg2: '上传图片大小不能超过 500kb!',
        hasBeenSent: '已发送',
        sendSuccess: '发送成功',
        cannotExceed: '的大小不能超过',
        UploadAttachments: '上传附件',
        psuploading: '可拖拽图片调整顺序,支持上传文件格式、尺寸根据各平台与定，大小不超过5M',
        none: '此功能正在开发，给您带来的使用不便深感抱歉！'
    },
    errorApi: '数据操作错误，请联系管理员',
    errorApi2: '请求服务器超时，请刷新重试',
    pendingApi: '数据处理中，请稍后查看',
};
